import { toast } from "sonner";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "ptr_token";
let token = localStorage.getItem(TOKEN_KEY);
let simulateId = localStorage.getItem("ptr_simulate");

export const setSimulate = (id) => {
  simulateId = id;
  if (id) localStorage.setItem("ptr_simulate", id);
  else localStorage.removeItem("ptr_simulate");
};
export const getSimulate = () => simulateId;

export const setToken = (t) => {
  token = t;
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getToken = () => token;

export async function api(path, opts = {}) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  if (simulateId) headers["X-Simulate-User"] = simulateId;
  const dev = localStorage.getItem("crew_device");
  if (dev && path === "/auth/login") headers["X-Device-Token"] = dev;
  let body;
  if (opts.body !== undefined) {
    headers["Content-Type"] = "application/json";
    body = JSON.stringify(opts.body);
  }
  let res;
  try {
    res = await fetch(`${BASE}/api${path}`, { method: opts.method || (opts.body ? "POST" : "GET"), headers, body });
  } catch {
    throw new Error("Connessione al server non riuscita. Riprova.");
  }
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  if (!res.ok) {
    if (res.status >= 500) {
      toast.error("Server Crew momentaneamente non disponibile, riprova tra poco", { id: "upstream-down" });
      const err = new Error("Server momentaneamente non disponibile, riprova tra poco");
      err.status = res.status;
      throw err;
    }
    const d = data && (data.detail || data.message);
    const err = new Error(typeof d === "string" ? d : "Errore");
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function apiBlob(path) {
  const res = await fetch(`${BASE}/api${path}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new Error("Errore nel download");
  return res;
}

export async function apiUpload(path, form) {
  const res = await fetch(`${BASE}/api${path}`, { method: "POST", headers: token ? { Authorization: `Bearer ${token}` } : {}, body: form });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Errore upload");
  return data;
}

export const downloadBlob = async (blob, name) => {
  const standalone = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
  const file = typeof File !== "undefined" ? new File([blob], name, { type: blob.type }) : null;
  if (standalone && file && navigator.canShare?.({ files: [file] })) {
    try { await navigator.share({ files: [file], title: name }); return; } catch (e) { if (e?.name === "AbortError") return; }
  }
  const url = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: url, download: name, rel: "noopener" });
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export async function exportFile(path) {
  const d = await api(path);
  if (!d?.base64) throw new Error("File non disponibile");
  const bin = Uint8Array.from(atob(d.base64), (c) => c.charCodeAt(0));
  await downloadBlob(new Blob([bin], { type: d.mimetype }), d.filename);
}

export const fileToDataUrl = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = reject;
  r.readAsDataURL(file);
});

export async function compressImage(file, maxSide = 1600, quality = 0.75) {
  const src = await fileToDataUrl(file);
  const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });
  const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
  const c = document.createElement("canvas");
  c.width = Math.round(img.width * scale);
  c.height = Math.round(img.height * scale);
  c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
  return c.toDataURL("image/jpeg", quality);
}
